import React from 'react';
import { Box, Typography, Link  } from '@mui/material';
import warningIcon from "./../../asset/warning.svg";

const ErrorMessage = ({ errors, type = 'server' }) => {

  if (!errors || errors.length === 0) {
    return null; // If no errors, render nothing
  }

  return (
    <Box style={ styles.box}>
      {/* Icon */}
      <img
        className ='gamutImg'
        src= { warningIcon }
        title= "Error"
        alt = "Page having some errors.."
        style={{ height: '30px', width: '30px' }}
      />
       {/* Default error message  */}
      
      <Typography variant="h5" component="h1" style={styles.load }>
        We couldn't load this page
      </Typography>

      {/* Show in case multiple error message */}
      { errors?.length > 1 ? (
          <ul style={styles.errorList}>
            {errors?.map((error, index) => (
              <li key={index} style={styles.listItem}>
                {error?.msg}
              </li>
            ))}
          </ul>
        ):  errors.length === 1 ?
        (
          <Typography variant="h5" component="h1" style={styles.evaluate}>
            {/* Show in case of single error without list  */}
            { errors[0]['msg'] }
          </Typography>
        ): (
          <Typography variant="h5" component="h1" style={styles.evaluate}>
            {/* Show in case of server error */}
              Try to &nbsp;
              <Link to="/home" style={styles.link}>Evaluate Color</Link>
              &nbsp; again. If this problem persists, contact ColorNow support.
          </Typography>
        )}
  </Box>
  );
};

// Optional styles to make it look better
const styles = {
  box: {
    display: 'flex',
      flexDirection: 'column',    // Stack icon and text vertically
      justifyContent: 'center',   // Center horizontally
      alignItems: 'center',       // Center vertically
      minHeight: '40vh',            // Full viewport height
      overflow: 'auto', 
  },
  load: {
    fontWeight: 'bold',
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    mt: '3px',
    color: 'rgb(80,80,80)',
    letterSpacing: '0.8px',
     margin: '7px'
  },
  evaluate: {
    fontWeight: 'normal',
    fontFamily: 'Source Sans Pro',
    fontSize: '12px',
    mt: '0px',
    color: 'rgb(80,80,80)',
    letterSpacing: '0.8px',
  },
  listItem: {
    fontWeight: 'normal',
    fontFamily: 'Source Sans Pro',
    fontSize: '12px',
    mt: '3px',
    color: 'rgb(80,80,80)',
    letterSpacing: '0.8px',
    padding: 3,
    margin: 0,
  },
  link: {
    fontWeight: 'bold',
    color: '#385DAE'
  },
  bulletIcon: {
    minWidth: '30px', // Adjust size of the bullet
    color: 'error.main', // Color of the bullet icon
  },
  errorList: {
    listStyleType: 'disc', // This will display default bullets
    paddingLeft: '20px', // Adds space on the left for the bullets
    margin: 2,
    color: '#d32f2f', // Red color for error text
    marginLeft: '20px',
  },
};

export default ErrorMessage;
